import React from "react";
import { useNavigate } from "react-router-dom";
import "./TermsPage.css"; // Import external CSS file

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="terms-container">
      <div className="terms-card">
        <div className="terms-header">
          <h1 className="terms-title">Terms & Conditions</h1>
        </div>



      <div className="textdata">
    
      <h2>1. Privacy Policy</h2>
    <h3>1.1 Introduction</h3>
    <p>CandiClie Consultancy Pvt. Ltd. ("Company," "We," "Us," or "Our") respects your privacy and is
committed to safeguarding the personal data of our clients, candidates, and website users
worldwide. This Privacy Policy outlines in comprehensive detail how we collect, process, use,
store, and protect your personal data in compliance with the <b> Indian IT Act, 2000 (as amended),
the General Data Protection Regulation (GDPR), the California Consumer Privacy Act
(CCPA), and other global data protection regulations.</b></p>

<p>This policy applies to every individual or entity engaging with CandiClie Consultancy Pvt. Ltd.,
including but not limited to job seekers, employers, business clients, website visitors, and other
users who interact with our digital platforms, services, and consultancy.</p>
    
    <h3>1.2 Data Collection: Categories and Sources</h3>
    <p>Our company collects and processes various types of data for different stakeholders. The data
    categories include:</p>
    <ul>
        <li><strong>For Candidates:</strong>
            <ol type="a">
                <li>Personal Information: Full Name, Contact Number, Email Address</li>
                <li>Employment History: Past jobs, references, and relevant experience</li>
                <li>Educational Background: University/Institute details, qualifications, and grades</li>
                <li>Professional Details: Skills, certifications, industry expertise</li>
                <li>Digital Footprint: Resume, Portfolio, Social Media links</li>
                <li>Additional Data: Information provided during assessments or interviews</li>
            </ol>
        </li>
        <li><strong>For Clients (Employers & Business Entities):</strong>
            <ol type="a">
                <li>Business Identity: Registered Name, Legal Entity Information</li>
                <li>Contact Information: Business Email, Telephone, Physical Address</li>
                <li>Financial Details: Payment history, invoices, banking details (secured and encrypted)</li>
                <li>Engagement History: Communications, service preferences, past projects</li>
            </ol>
        </li>
        <li><strong>For Website Users:</strong>
            <ol type="a">
                <li>Technical Data: IP Address, Device Information, Browsing Behavior</li>
                <li>Cookies & Analytics Data: Information collected through website interactions</li>
                <li>Voluntary Submissions: Forms, inquiries, surveys, and reviews</li>
            </ol>
        </li>
    </ul>
    
    <h3>1.3 Purpose of Data Collection & Processing</h3>
    <p>We collect and use data strictly for legitimate business purposes, which include:</p>
    <ul>
        <li><b>Facilitating recruitment and placement:</b> We collect candidate information to match
them with potential job opportunities that align with their qualifications, experience, and
career goals. This includes sharing resumes with prospective employers, conducting
preliminary screenings, and arranging interviews. The data enables a smooth
recruitment process, ensuring that candidates find suitable positions and employers hire
qualified professionals.</li>

        <li><b>Providing IT, recruitment, digital marketing, and consulting services:</b> Client data is used to understand specific business needs,
develop customized IT solutions, create digital marketing strategies, and provide
consultancy services that align with their objectives. This ensures efficient service
delivery tailored to the client's business model.</li>


        <li><b>Enhancing user experience:</b> By analyzing browsing behavior and interaction with our
website, we optimize website performance, improve navigation, ensure security, and
provide a seamless user experience. Tracking cookies and analytics help us understand
how users engage with our content and services, allowing us to refine our offerings
accordingly.</li>

        <li><b>Communication and customer support:</b> We use collected data to send essential
updates, respond to customer inquiries, and provide personalized support. This includes
answering service-related queries, assisting candidates with job applications, and
resolving technical issues faced by clients while accessing our platform.</li>

        <li><b>Regulatory and legal compliance:</b> To ensure compliance with national and
international data protection laws, we collect necessary user information for identity
verification, fraud prevention, and dispute resolution. Our policies align with GDPR,
CCPA, and other legal frameworks, ensuring transparency and adherence to regulatory
requirements.</li>
    </ul>


    <h3>1.4 Data Protection & Security</h3>
<p>To safeguard collected data, we employ robust security measures, including but not limited to:</p>
<ul>
    <li><b>Data Encryption:</b>
        <ol>
            <li>All sensitive data, including personal and financial information, is encrypted using <b> AES-256 encryption</b>  standards during transmission and storage.</li>
            <li>Secure Socket Layer (SSL) technology is implemented to establish an encrypted connection between users and our servers.</li>
        </ol>
    </li>
    <li><b>Restricted Access:</b>
        <ol>
            <li>Only authorized personnel with predefined roles and permissions have access to critical information.</li>
            <li>Multi-factor authentication (MFA) is used to enhance access control mechanisms.</li>
            <li>Regular role-based access reviews are conducted to ensure minimal exposure to sensitive data.</li>
        </ol>
    </li>
    <li><b>Secure Infrastructure:</b>
        <ol>
            <li>We maintain compliance with <b> ISO/IEC 27001 </b>standards for information security management.</li>
            <li>Regular updates and security patches are applied to our IT systems and databases to prevent vulnerabilities.</li>
            <li>Data centers are equipped with advanced firewalls, intrusion detection, and prevention systems (IDPS).</li>
        </ol>
    </li>
    <li><b>Regular Audits & Compliance Checks:</b>
        <ol>
            <li>Periodic security audits, vulnerability assessments, and penetration testing are conducted to identify and mitigate risks.</li>
            <li>Internal and third-party audits ensure adherence to industry standards and regulatory requirements.</li>
            <li>Comprehensive incident response protocols are in place to handle potential security breaches effectively.</li>
        </ol>
    </li>
    <li><b>Data Anonymization & Pseudonymization:</b>
        <ol>
            <li>Sensitive user data is anonymized or pseudonymized where applicable, ensuring privacy protection while maintaining usability.</li>
        </ol>
    </li>
    <li><b>Continuous Monitoring & Threat Detection:</b>
        <ol>
            <li>AI-powered monitoring tools are deployed to track network activity, detect anomalies, and prevent cyber threats.</li>
            <li>Automated alerts and real-time logging help in rapid identification and mitigation of potential breaches.</li>
        </ol>
    </li>
</ul>
<p>By implementing these measures, we ensure that the confidentiality, integrity, and availability of
user data are maintained at the highest standards.</p>

<h3>1.5 User Rights & Data Retention Policy</h3>
<p>Users have the right to:</p>
<ul>
    <li><b>Request Access</b> to their data (subject to verification and legal constraints).</li>
    <li> <b> Modify or Correct Information </b> stored in our records to ensure accuracy.</li>
    <li> <b>Withdraw Consent or Request Data Deletion</b> under GDPR (General Data Protection Regulation) and <b>Indian IT Act provisions</b> where applicable.</li>
    <li><b>File Complaints </b>if they believe their data has been used in an unauthorized manner or in violation of applicable laws. Complaints can be directed to our designated <b> Data
Protection Officer (DPO) </b>or relevant legal authorities. Action is completely subject to
fact checking about complaints. We can ask</li>
    <li><b>Portability of Data:</b> Users have the right to request a structured, commonly used, and
machine-readable format of their personal data for transfer to another service provider
where technically feasible.</li>
    <li><b>Opt-Out of Automated Processing:</b> Users can request to opt out of automated
    decision-making processes where profiling or automated processing affects their rights.</li>
</ul>

<h6>Data Retention Policy:</h6>
<ul>
    <li>Personal data is retained <b> only as long as necessary</b> to fulfill the intended purposes and legal obligations.</li>
    <li> <b>Employment and recruitment records</b> are securely stored for a minimum of <b> 5 years after contractual engagement ends</b> to comply with Indian labor laws and taxation requirements.</li>
    <li><b>Transaction records, invoices, and payment details</b> are retained for 7 years for financial auditing and regulatory compliance.</li>
    <li><b>Website and user interaction logs</b> are kept for 12 months for analytics and security purposes before being anonymized or deleted.</li>
</ul>

<h3>1.6 Third-Party Data Sharing & International Transfers</h3>
<p>We share data only under legally permissible conditions, such as:</p>
<ul>
    <li><b>Regulatory Compliance:</b> When government agencies or legal authorities require disclosure under applicable laws, including GDPR, the Indian IT Act, and other jurisdictional mandates.</li>
    <li><b>Third-Party Service Providers:</b> We may share limited user data with trusted partners, including payment processors, CRM platforms, cloud storage providers, and cybersecurity firms, operating under strict confidentiality agreements.</li>
    <li><b>International Business Operations:</b> Cross-border data transfers may occur under EU Standard Contractual Clauses (SCCs), GDPR requirements, and Indian IT Act guidelines.</li>
    <li><b>Mergers & Acquisitions:</b> In the event of corporate restructuring, merger, or acquisition, data may be transferred with due notice and consent provisions.</li>
    <li><b>Fraud Prevention & Risk Assessment:</b> Data may be shared with legal enforcement agencies and security partners to mitigate risks and detect fraudulent activities.</li>
</ul>

<h3>1.7 Disclaimer on Payment Frauds and Third-Party Services</h3>
<ul>
    <li>CandiClie Consultancy Pvt. Ltd. does not take responsibility for <b> payment frauds or
unauthorized transactions </b>conducted outside our official payment channels. Users
must verify payment details before proceeding.</li>
    <li>We do not assume liability for <b> financial losses </b>due to third-party payment gateways,
external job portals, or unauthorized recruitment agents falsely claiming association with
our company.</li>
    <li>All job offers, invoices, and transactions must be confirmed through our <b> official email
    domain (@candiclie.com) or registered contact details</b> to avoid fraud.</li>

    <li>If any user encounters suspicious activity, it should be reported immediately to our fraud
    prevention team at ( <a href="legal@candiclie.com">legal@candiclie.com</a> OR <a href="info@candiclie.com">info@candiclie.com</a> ).</li>
</ul>







    
    <h2>2. Terms and Conditions</h2>
    <h3>2.1 Legal Framework & Acceptance of Terms</h3>
    <p>By accessing or using CandiClie Consultancy’s services, website, or digital platforms, users
agree to abide by these legally binding <b>Terms and Conditions.</b> These terms govern access,
usage, and all transactions related to our consultancy services.</p>
    
    <h3>2.2 Intellectual Property Rights</h3>
    <ul>
        <li><b>Website Structure, UX/UI, and Development:</b> Entirely owned by CandiClie
        Consultancy Pvt. Ltd.</li>
        <li><b>Trademarks, Logos, Taglines, and Visual Assets:</b> Exclusive intellectual property of
        the company.</li>
        <li><b>Content Ownership: </b>Screenshots, documentation, graphics, and written materials are
proprietary assets and cannot be replicated, distributed, or modified without prior
permission.</li>
        <li><b>Editing & Re-Design Rights:</b> Any modifications made to images, GIFs, and multimedia
        remain the sole property of CandiClie Consultancy.</li>
        <li><b>Image Sources: </b>Images used for website development are sourced from Freepik,
Pixabay, Pinterest, and similar platforms. CandiClie Consultancy is not directly
involved in designing original images but modifies and re-designs them as per
business requirements.</li>
    </ul>

    <p>Violations of intellectual property rights may result in <b> legal actions, penalties, and contractual
    consequences.</b></p>
    
    <h2>3. Refund Policy</h2>
    <h3>3.1 Eligibility for Refunds</h3>
    <p>We maintain a strict <b> no-refund policy,</b> except in the following circumstances:</p>
    <ul>
        <li><b>Service Non-Delivery: </b>If services were not provided within agreed timelines due to our
        error.</li>
        <li><b>Duplicate Transactions:</b> Unintentional multiple payments made by a client, subject to
        verification.</li>
    </ul>
    
    <h3>3.2 Non-Refundable Cases</h3>
    <ul>
        <li><b>Completed Services: </b>If a project or service has been successfully delivered.</li>
        <li><b>Client-Initiated Delays: </b>When clients fail to provide required approvals, documents, or
        feedback.</li>
        <li><b>Third-Party Interference: </b>Refunds are not applicable for external service integrations
        handled through CandiClie.</li>
    </ul>

    <p>Refunds (where applicable) will be processed within 7-14 business days.</p>
    
    <h2>4. Governing Law & Legal Jurisdiction</h2>
    <p>All disputes, legal claims, and contractual issues fall under <b> Indian law, specifically within the
jurisdiction of the State Government and City Court ( In the city where the company is
registered).</b> All the International clients agree to Indian legal authority unless exempted by
international treaties. <b> Any IP violation, fraud, or breach exceeding INR 10,00,000 may result
in escalation to higher courts.</b></p>
    
    <h2>5. Sister Concerns & Future Initiatives</h2>
    <p>CandiClie Consultancy has expanded its footprint into multiple specialized ventures, further strengthening its market present. This initiatives include:</p>
    <ul>
        <li><b>CandiClie IT Solutions: </b>Advanced technology services catering to corporate needs.</li>
        <li><b>CandiClie Digital Marketing:</b> A dedicated wing offering digital transformation strategies.</li>
        <li><b>CandiClie Recruitment Services:</b> Focused on global talent acquisition.</li>
    </ul>
    <p>Each entity operates under the same legal framework and intellectual property policies as
    CandiClie Consultancy.</p>
    
    <h2>6. Contact Information & Legal Assistance</h2>
    <p>For any legal queries, compliance concerns, or policy clarifications, please reach out:</p>
    <ul>
        <li><b> Legal Department, CandiClie Consultancy Pvt. Ltd.</b></li>
        <li>Email: <a href="legal@candiclie.com">legal@candiclie.com</a>  OR <a href="info@candiclie.com">info@candiclie.com</a> </li>
        <li>Registered Office Address: As mentioned over the website</li>
    </ul>
    <p>By continuing to engage with our services, you acknowledge and accept the legal policies
    outlined in this document.</p>

    <h2>Terms of Service Updates and Amendments</h2>
    <p>The company reserves the right to modify, update, or amend any terms, policies, and conditions
at its sole discretion, without prior notice. Such changes will be effective immediately upon being
posted. It is the responsibility of all users to regularly review these terms, policies, and
conditions to stay informed of any updates. Your continued use of our services following any
changes constitutes acceptance of those changes.</p>

    </div>




    
          <button className="go-back-btn" onClick={() => navigate(-1)}>Go Back</button>
    
      </div>
    </div>
  );
};

export default TermsPage;
